import * as yup from 'yup';
import { IName, ResidentNameSchema } from '../../common';
import { IResidentBaseData, ResidentBaseDataSchema } from './resident-base-data';

export const ResidentSchema = yup.object({
  identifier: yup.string().required(),
  alternativeIndicatorNumber: yup.string().notRequired(),
  name: ResidentNameSchema.required(),
  residentBaseData: ResidentBaseDataSchema.notRequired(),
  nursingHomeId: yup.string().notRequired(),
});

export const UpdateResidentSchema = yup.object({
  id: yup.string().required(),
  identifier: yup.string().optional(),
  alternativeIndicatorNumber: yup.string().optional(),
  name: ResidentNameSchema.notRequired().default(undefined),
  residentBaseData: ResidentBaseDataSchema.notRequired().default(undefined),
  nursingHomeId: yup.string().notRequired().default(undefined),
});

export interface IResident {
  id: string;
  identifier: string;
  alternativeIndicatorNumber?: string;
  name: IName;
  residentBaseData?: IResidentBaseData;
  nursingHomeId?: string;
  isAbsent?: boolean;
}

export interface IUpdateResident {
  id: string;
  identifier?: string;
  alternativeIndicatorNumber?: string;
  name?: IName;
  residentBaseData?: IResidentBaseData;
  nursingHomeId?: string;
}

export interface IResidentHeaderFlags {
  isAbsent: boolean;
  isDyingPhase: boolean;
  hasInfectiousDisease: boolean;
  hasMultiResistantGerm: boolean;
  hasCognitiveLimitations: boolean;
  hasMedicationAdministration: boolean;
  careLevel: string;
}
